var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "img-box" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading && _vm.showLoadingImg,
              expression: "loading && showLoadingImg",
            },
          ],
          staticClass: "loading-box",
        },
        [_c("div", { staticClass: "mg-loading" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "img-content",
          style: { zIndex: _vm.loading ? "-1" : "0" },
        },
        [
          _c("site-img", {
            attrs: {
              src: _vm.src,
              type: "img",
              dir: _vm.dir,
              size: _vm.size,
              alt: _vm.alt,
              rate: _vm.rate,
              errorImg: _vm.errorImg,
              lazy: _vm.lazy,
            },
            on: {
              update: _vm.imgUpdate,
              load: function ($event) {
                return _vm.imgLoad($event)
              },
              error: _vm.imgError,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }